export { AvatarSize, User, UserAvatarComponent } from './user-avatar.component';
